/**
 * Injeta a seção Video Testimonials da home na PDP e em coleções (mesmos vídeos, um só lugar para configurar).
 */
(function () {
  const mount = document.querySelector('[data-vestfirma-home-videos]');
  if (!mount) return;

  const path = window.location.pathname;
  const isProduct = path.includes('/products/');
  const isCollection = path.includes('/collections/');
  const materialFamily = (mount.dataset.materialFamily || '').trim();

  if (!isProduct && !isCollection) {
    mount.remove();
    return;
  }

  if (isCollection && materialFamily !== 'prata' && materialFamily !== 'ouro') {
    mount.remove();
    return;
  }

  if (document.querySelector('.video-testimonials')) {
    mount.remove();
    return;
  }

  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  const getPreviewThemeId = () => {
    const params = new URLSearchParams(window.location.search);
    return (params.get('preview_theme_id') || '').trim();
  };

  const withPreview = (url) => {
    const previewId = getPreviewThemeId();
    if (!previewId) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}preview_theme_id=${encodeURIComponent(previewId)}`;
  };

  const loadStylesheet = () =>
    new Promise((resolve) => {
      const href = mount.dataset.carouselCss || '';
      if (!href) {
        resolve();
        return;
      }
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = () => resolve();
      document.head.appendChild(link);
    });

  const loadSwatches = () =>
    new Promise((resolve) => {
      const src = mount.dataset.swatchesSrc || '';
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const loadScript = () =>
    new Promise((resolve) => {
      if (customElements.get('video-testimonials-carousel')) {
        resolve();
        return;
      }
      const existing = document.querySelector('script[src*="video-testimonials-carousel"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => resolve(), { once: true });
        return;
      }
      const s = document.createElement('script');
      s.src = mount.dataset.carouselSrc || '';
      if (!s.src) {
        resolve();
        return;
      }
      s.defer = true;
      s.onload = () => {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const fetchSectionHtml = async (sectionKey) => {
    const res = await fetch(withPreview(`${root}?sections=${encodeURIComponent(sectionKey)}`), {
      credentials: 'same-origin',
    });
    if (!res.ok) return '';
    const sections = await res.json();
    const html = sections[sectionKey];
    if (!html || String(html).trim().length < 50) return '';
    return String(html);
  };

  const discoverSectionKeyFromHome = async () => {
    try {
      const res = await fetch(withPreview(`${root}`), { credentials: 'same-origin' });
      if (!res.ok) return '';
      const html = await res.text();
      const match = html.match(/shopify-section-(template--[^"'\\s]+__video_testimonials)/);
      return match ? match[1] : '';
    } catch (_) {
      return '';
    }
  };

  const resolveSectionKey = async () => {
    const candidates = [];
    const hinted = (mount.dataset.sectionKey || '').trim();
    const themeKey = (mount.dataset.themeSectionKey || '').trim();
    const themeId = (mount.dataset.themeId || '').trim();
    const sectionHandle = (mount.dataset.sectionHandle || 'video_testimonials').trim();

    if (themeId) {
      candidates.push(`template--${themeId}__${sectionHandle}`);
    }
    if (hinted) candidates.push(hinted);
    if (themeKey && themeKey !== hinted) candidates.push(themeKey);

    const discovered = await discoverSectionKeyFromHome();
    if (discovered && !candidates.includes(discovered)) candidates.push(discovered);

    for (const key of candidates) {
      if (!key.includes('__video_testimonials')) continue;
      const html = await fetchSectionHtml(key);
      if (html) return { key, html };
    }

    return { key: '', html: '' };
  };

  const shouldPreserveScroll = () => {
    const hash = (window.location.hash || '').replace('#', '');
    return hash === 'md-pdp-ficha' || hash === 'md-pdp-descricao' || hash === 'md-pdp-detalhes';
  };

  const restoreScrollPosition = (savedY) => {
    window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  };

  const showMountError = () => {
    mount.setAttribute('aria-busy', 'false');
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      mount.classList.add('md-pdp__videos-mount--error');
      mount.innerHTML =
        '<p class="md-pdp__videos-mount-msg">Não foi possível carregar os vídeos. Edite em <strong>Personalizar → Página inicial → Video Testimonials</strong>.</p>';
      return;
    }
    mount.remove();
  };

  const applyMaterialHeadings = (sectionEl) => {
    const family = (mount.dataset.materialFamily || '').trim();
    if (family !== 'prata' && family !== 'ouro') return;

    const videoRoot = sectionEl.querySelector('.video-testimonials') || sectionEl;
    const wrap = videoRoot.querySelector('.video-testimonials__wrap');
    if (!wrap) return;

    const eyebrow = mount.getAttribute(`data-vt-eyebrow-${family}`) || '';
    const heading = mount.getAttribute(`data-vt-heading-${family}`) || '';
    const subheading = mount.getAttribute(`data-vt-subheading-${family}`) || '';

    const eyebrowEl = wrap.querySelector('.vestfirma-section-header__eyebrow');
    const headingEl = wrap.querySelector('.vestfirma-section-header__title');
    const subheadingEl = wrap.querySelector('.vestfirma-section-header__sub');

    if (eyebrowEl && eyebrow) eyebrowEl.textContent = eyebrow;
    if (headingEl && heading) headingEl.textContent = heading;
    if (subheadingEl && subheading) subheadingEl.textContent = subheading;

    wrap.hidden = false;
    wrap.removeAttribute('hidden');

    const materialClasses = ['video-testimonials--material', `video-testimonials--${family}`];
    materialClasses.forEach((className) => {
      videoRoot.classList.add(className);
      sectionEl.classList.add(className);
    });

    if (isProduct) {
      videoRoot.classList.add('video-testimonials--pdp-material', `video-testimonials--pdp-${family}`);
      sectionEl.classList.add('video-testimonials--pdp-material', `video-testimonials--pdp-${family}`);
    }
    if (isCollection) {
      videoRoot.classList.add('video-testimonials--collection-material', `video-testimonials--collection-${family}`);
      sectionEl.classList.add('video-testimonials--collection-material', `video-testimonials--collection-${family}`);
    }
  };

  const afterInject = (sectionEl) => {
    const preserveScroll = shouldPreserveScroll();
    const savedY = preserveScroll ? window.scrollY : null;

    applyMaterialHeadings(sectionEl);
    mount.remove();

    const carousels = sectionEl.querySelectorAll('video-testimonials-carousel');
    carousels.forEach((el) => {
      if (typeof customElements.upgrade === 'function') customElements.upgrade(el);
    });

    const refresh = () => window.VestfirmaVideoCarousel?.refresh(sectionEl);

    refresh();
    [100, 300, 600, 1200, 2500].forEach((ms) => window.setTimeout(refresh, ms));

    sectionEl.querySelectorAll('video').forEach((video) => {
      video.addEventListener('loadeddata', refresh, { once: true });
      video.addEventListener('canplay', refresh, { once: true });
    });

    if (preserveScroll && savedY != null) {
      let cancelled = false;
      const cancelRestore = () => {
        cancelled = true;
      };

      window.addEventListener('wheel', cancelRestore, { once: true, passive: true });
      window.addEventListener('touchmove', cancelRestore, { once: true, passive: true });
      window.addEventListener(
        'keydown',
        (event) => {
          if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', ' ', 'Spacebar'].includes(event.key)) {
            cancelRestore();
          }
        },
        { once: true }
      );

      const restore = () => {
        if (cancelled) return;
        restoreScrollPosition(savedY);
      };

      restore();
      requestAnimationFrame(restore);
      [50, 150, 350].forEach((ms) => {
        window.setTimeout(restore, ms);
      });
    }
  };

  const insertSection = (sectionEl) => {
    if (mount.parentNode) {
      mount.insertAdjacentElement('beforebegin', sectionEl);
      return;
    }

    const credibilityAnchor =
      document.querySelector('[data-md-pdp-credibility]') ||
      document.querySelector('.md-pdp-credibility');

    if (credibilityAnchor) {
      credibilityAnchor.insertAdjacentElement('afterend', sectionEl);
      return;
    }

    const collectionAnchor = document.querySelector('results-list');
    if (collectionAnchor) {
      collectionAnchor.insertAdjacentElement('afterend', sectionEl);
      return;
    }

    mount.replaceWith(sectionEl);
  };

  const injectFromHtml = (html) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const sectionEl =
      wrapper.querySelector('.shopify-section, [id^="shopify-section-"]') || wrapper.firstElementChild;
    if (!sectionEl) throw new Error('no section element');
    insertSection(sectionEl);
    afterInject(sectionEl);
  };

  const loadVideos = async (attempt = 0) => {
    try {
      await Promise.all([loadStylesheet(), loadSwatches()]);
      await loadScript();

      const resolved = await resolveSectionKey();
      if (!resolved.html) throw new Error('section not found');

      injectFromHtml(resolved.html);
    } catch (_) {
      if (attempt < 3) {
        window.setTimeout(() => loadVideos(attempt + 1), 600 + attempt * 400);
        return;
      }
      showMountError();
    }
  };

  const scheduleLoad = () => {
    if (isProduct) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => loadVideos(), { timeout: 5000 });
      } else {
        window.setTimeout(() => loadVideos(), 2500);
      }
      return;
    }
    loadVideos();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLoad);
  } else {
    scheduleLoad();
  }
})();
